import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class SurveyResult extends DomainObject {
  @observable trend;
  @observable currentPeriodDate;
}

export default SurveyResult;
